import React from 'react'
import PropTypes from 'prop-types'
import './TextAreaField.css'
import { compose, pure } from 'recompose'

const TextAreaField = ({ handleChange, limitLength, currentText }) => {
  return (
    <div styleName="group">
      <textarea
        styleName="textarea"
        maxLength={limitLength}
        onChange={e => handleChange(e.target.value)}
        value={currentText}
      />
      <span styleName="highlight" />
      <span styleName="bar" />
    </div>
  )
}

TextAreaField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  limitLength: PropTypes.number,
  currentText: PropTypes.string
}

TextAreaField.defaultProps = {
  currentText: ''
}

export default compose(pure)(TextAreaField)
